import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '../../../../theme/Theme.js';
import { Root as Root$1 } from './styled.js';
import { AvatarContext } from '../../contexts/AvatarContext.js';

const Root = React.forwardRef((_a, ref) => {
    var { children, size = 'medium', className } = _a, props = __rest(_a, ["children", "size", "className"]);
    const [imageLoadingStatus, setImageLoadingStatus] = React.useState('idle');
    const theme = useTheme();
    return (React.createElement(AvatarContext, { value: React.useMemo(() => ({
            imageLoadingStatus,
            onImageLoadingStatusChange: setImageLoadingStatus,
        }), [imageLoadingStatus]) },
        React.createElement(Root$1, Object.assign({ "data-testid": 'tend-ui-avatar-root' }, props, { ref: ref, theme: theme, "$size": size, className: ['tend-ui-avatar-root', className].filter(Boolean).join(' ') }), children)));
});
Root.displayName = 'Avatar.Root';

export { Root };
//# sourceMappingURL=Root.js.map
